import React, { Component } from 'react';
import FormPushNotification from './Form/FormPushNotification';
import { getPushNotificationDetails, updatePushNotification, sendPushNotificationEvent } from '../../data/PushNotifications/actions';

class PushNotificationDetails extends Component {
    render() {
        return (
            <FormPushNotification
                type="update"
                sendDataFunc={updatePushNotification}
                sendEventFunc={sendPushNotificationEvent}
                getDetailsFunc={getPushNotificationDetails}
            />
        );
    }
}

export default PushNotificationDetails;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/PushNotification/details.js